import React from "react";

// Puce d'un événement "journée entière" (ex. anniversaire Google) — une
// bande dédiée au-dessus de la grille horaire, comme Google Calendar :
// ces événements n'ont pas d'heure et ne peuvent pas se positionner dans
// la grille des RDV.
function AllDayEventChip({ title, color, onClick }) {
  return (
    <button
      onClick={onClick}
      title={title}
      className="w-full truncate text-left text-[9.5px] font-semibold"
      style={{ background: color, color: "#fff", borderRadius: 4, padding: "2px 6px" }}
    >
      {title}
    </button>
  );
}

export default AllDayEventChip;
